import './EmptyResults.scss'

import { HDSIcon } from '@here/hds-react-components'
import classNames from 'classnames'
import { ScrollableContainer } from 'components/App/components/ScrollableContainer'
import React from 'react'

interface EmptyResultsProps {
  title: string
  message: string
  className?: string
}

export function EmptyResults({ title, message, className }: EmptyResultsProps): JSX.Element {
  const iconStyle = {
    '--hds-icon-color': 'var(--hds-foreground-primary)',
  } as React.CSSProperties

  return (
    <ScrollableContainer className="EmptyResults__scrollable-container">
      <div className={classNames('EmptyResults', className)}>
        <HDSIcon className="EmptyResults__icon" name="redo" style={iconStyle} size="20" />
        <div className="EmptyResults__title">{title}</div>
        <div className="EmptyResults__message">{message}</div>
      </div>
    </ScrollableContainer>
  )
}
